module.exports = __webpack_public_path__ + "img/20.83e4daa9.jpg";